module.exports = __webpack_public_path__ + "static/media/54-iveco-mercedes.3eae5ab4.jpg";